module.exports = __webpack_public_path__ + "static/media/arrow-down-fill.aad975a1.svg";